import React, { useEffect, useState } from 'react';
import Footer from '../../shared/footer/Footer';
import LoginModal from '../../main/loginModal/LoginModal';
import Head from '../../Global/Head';
import Header from '../../Global/Header';
import { AiOutlineCalendar, AiOutlineShareAlt } from 'react-icons/ai';
import { HiOutlineLocationMarker } from 'react-icons/hi';
import { BsBookmark } from 'react-icons/bs';

export default function Blog5() {
  const accessToken = localStorage.getItem("@user");
  const [isVisible, setIsVisible] = useState(!!accessToken ? false : true);
  const [topPosition, setTopPosition] = useState(50);

  useEffect(() => {
    let interval;
    const totalTime = 1500;
    const steps = 800;
    const intervalTime = totalTime / steps;
    const increment = 1300 / steps;

    if (isVisible) {
      interval = setInterval(() => {
        setTopPosition((prev) => {
          if (prev <= 0) {
            clearInterval(interval);
            return 0;
          }
          return prev - increment;
        });
      }, intervalTime);
    }

    return () => clearInterval(interval);
  }, [isVisible]);

  const slideGoDown = () => {
    const totalTime = 1500; // Total animation time
    const steps = 800; // Number of steps
    const intervalTime = totalTime / steps; // Time per step
    const increment = 1300 / steps; // Position change per step

    let interval = setInterval(() => {
      setTopPosition((prev) => {
        if (prev >= 80) {
          clearInterval(interval); // Stop the interval
          setTimeout(() => setIsVisible(false), 0); // Change state after animation ends
          return 80; // Ensure it stops at the original position
        }
        return prev + increment; // Increment position to slide down
      });
    }, intervalTime);
  };

  const BlankModal = ({ isVisible, setIsVisible }) => {
    return (
      <div
        className={`fixed inset-0 z-[1000]  transition-opacity duration-300 ${
          isVisible ? "opacity-100 visible" : "opacity-0 invisible"
        }`}
      >
        <div
          className="absolute inset-0 login-slide-up  bg-black"
          onClick={() => setIsVisible(false)}
        ></div>
        <div className="relative w-full h-screen">
          <div
            style={{ top: `${topPosition}%` }} // Dynamic top position
            className="absolute w-full h-screen transition-none"
          >
            <LoginModal setIsVisible={setIsVisible} slideGoDOwn={slideGoDown} />
          </div>
        </div>
      </div>
    );
  };
  return (
    <div className="min-h-screen ">
      <BlankModal setIsVisible={setIsVisible} isVisible={isVisible} />
      <Head />

      <Header />
      <div className="max-w-7xl mx-auto p-6">
        <h1 className="text-4xl font-bold mt-4">Where Women Rise Together: Build Your Tribe on Hightable</h1>
        <div className="mt-4 flex items-start justify-between">
          <div className="flex items-center gap-4 text-sm text-gray-600">
           
            <div className="flex items-center gap-2">
              <span className="inline-block bg-black text-white px-2 py-0.5 rounded">HighTable</span>
            </div>
          </div>
         
        </div>

        <div className="mt-6 rounded-lg overflow-hidden">
          <img
            src="https://res.cloudinary.com/diecfwnp9/image/upload/v1761403966/IMG_0971_iqalyw.jpg"
            alt="Where Women Rise Together"
            className="w-full h-64 sm:h-96 object-cover"
          />
        </div>

        <div className="prose max-w-none mt-6">
          <p>
            In a world that constantly tells women to “do it all alone,” finding a supportive circle can feel like a superpower. Friendships, mentorship, and a tribe of like-minded women aren’t just nice-to-have—they’re essential for personal growth, confidence, and well-being. That’s why Hightable is committed to creating a safe, empowering space exclusively for women to connect, collaborate, and thrive.
          </p>

          <h3>Why Women Need Their Own Spaces</h3>
          <p>
            Women face unique challenges in both professional and personal spaces—bias, societal pressures, and the unspoken expectation to constantly juggle responsibilities. Having a tribe of women who understand, support, and inspire you can make all the difference.
          </p>

          <h3>Finding Your Tribe</h3>
          <p>
            A tribe is more than just a group of friends—it’s a support system. Hightable connects women through shared interests, mentorship opportunities, and interest-based groups so finding your people feels natural.
          </p>

          <h3>The Power of Shared Experiences</h3>
          <p>
            Shared experiences create bonds. On Hightable, curated spaces help conversations happen organically—whether it’s casual chats or deep mentorship sessions.
          </p>

          <h3>How Hightable Supports Women</h3>
          <p>
            Safety, inclusivity, and authenticity are our pillars. Discover peers and mentors, share knowledge in supportive spaces, build meaningful friendships, and celebrate milestones together.
          </p>

          <h3>The Takeaway</h3>
          <p>
            Building your tribe isn’t optional—it’s essential. On Hightable, women have a dedicated space to connect, share, and thrive together. If you’ve been searching for a community where authenticity and support come first, your tribe is waiting.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}
